import { IonDatetime, IonItem, IonLabel } from "@ionic/react"
import moment from 'moment'
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormBirthday: React.FC<Props> = props => {
  const max = moment().subtract(18, 'years').format('YYYY-MM-DD')
  const min = moment().add(90, 'years').format('YYYY-MM-DD')

  return (
    <IonItem>
      <IonLabel position="floating">Geburtstag</IonLabel>
      <IonDatetime
        min={min}
        max={max}
        value={props.value}
        displayFormat={'YYYY-MM-DD'}
        onIonChange={e => props.onChange((e.target as HTMLInputElement).value)}
      />
    </IonItem>
  )
}

export default FormBirthday
